(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("flat-dark-panelless", [], factory);
	else if(typeof exports === 'object')
		exports["flat-dark-panelless"] = factory();
	else
		root["SurveyTheme"] = factory();
})(this, function() {
return 